import React, { useContext } from "react";
import "./index.css";
import { getIndependentSymbol, getPercentage, getTimeAgo, translate, translateNumber, translatePercentage } from "../../../../helper";
import LangContext from "../../../../contexts/LangContext";


const CandidateSummary = ({ data, parties }) => {
  const { lang } = useContext(LangContext);
  // Calculate statistics from data
  const calculateStats = () => {
    if (!data || !data.provinces || data.provinces.length === 0) {
      return {
        totalCandidates: 3406,
        maleCount: 3017,
        femaleCount: 388,
        otherCount: 1,
        totalVoters: 18903689 
      };
    }

    let totalCandidates = 0;
    let maleCount = 0;
    let femaleCount = 0;
    let otherCount = 0;
    // Extract all candidates from nested structure
    data.provinces.forEach(province => {
      province.districts?.forEach(district => {
        district.regions?.forEach(region => {
          if (region.result && Array.isArray(region.result)) {
            region.result.forEach(candidate => {
              totalCandidates++;
              
              // Gender distribution
              if (candidate.gender === 'M' || candidate.gender === 'male') {
                maleCount++;
              } else if (candidate.gender === 'F' || candidate.gender === 'female') {
                femaleCount++;
              }
            });
          }
        });
      });
    });

    return {
      totalCandidates: totalCandidates || 3406,
      maleCount: maleCount ||  3017 ,
      femaleCount: femaleCount || 388,
      totalVoters: 18903689, 
      otherCount: otherCount || 1,
    };
  };

  const stats = calculateStats();
  const totalParties = 107;

  // Calculate percentages for gender bars
  const malePercentage = ((stats.maleCount / stats.totalCandidates) * 100).toFixed(1);
  const femalePercentage = ((stats.femaleCount / stats.totalCandidates) * 100).toFixed(1);

  return (
    <div className="candidate-summary-section container">
      <div className="stats-grid-summary">
        {/* Card 1: Total Candidates */}
        <div className="stat-card-summary highlight-summary">
          <div className="card-icon-summary">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
          </div>
          <div className="card-content-summary">
            <div className="card-title-summary">कुल दर्ता उम्मेदवारहरू</div>
            <div className="stat-value-summary">{translateNumber(stats.totalCandidates, lang)}</div>
          </div>
        </div>

        

        {/* Card 3: Political Parties */}
        <div className="stat-card-summary">
          <div className="card-icon-summary">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
          </div>
          <div className="card-content-summary">
            <div className="card-title-summary">दर्ता राजनीतिक दलहरू</div>
            <div className="stat-value-summary">{translateNumber(totalParties, lang)}</div>
            
          </div>
        </div>

        {/* Card 4: Total Voters */}
        <div className="stat-card-summary highlight-summary">
          <div className="card-icon-summary">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <div className="card-content-summary">
            <div className="card-title-summary">कुल दर्ता मतदाता</div>
            <div className="stat-value-summary">{translateNumber(stats.totalVoters, lang)}</div>
           
          </div>
        </div>

        {/* Card 2: Gender Distribution */}
        <div className="stat-card-summary">
          <div className="card-icon-summary">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="18" cy="5" r="3"></circle>
              <circle cx="6" cy="12" r="3"></circle>
              <path d="M13 19h6"></path>
              <path d="M3 22l3-3 3 3"></path>
              <path d="M18 8v2"></path>
              <path d="M18 16v5"></path>
            </svg>
          </div>
          <div className="card-content-summary card-content-summary-gender">
            <div className="card-content-summary-header">
                <div className="card-title-summary">उम्मेदवारहरूको लैंगिक वितरण</div>
                <div className="stat-value-summary">{translateNumber(stats.totalCandidates, lang)}</div>
            </div>
            <div className="gender-distribution-summary">
              <div className="gender-row-summary">
                <div className="gender-label-summary">पुरुष</div>
                <div className="gender-value-summary">{translateNumber(stats.maleCount, lang)}</div>
                <div className="gender-bar-summary">
                  <div className="gender-fill-summary male-fill-summary" style={{ width: `${malePercentage}%` }}></div>
                </div>
              </div>
              <div className="gender-row-summary">
                <div className="gender-label-summary">महिला</div>
                <div className="gender-value-summary">{translateNumber(stats.femaleCount, lang)}</div>
                <div className="gender-bar-summary">
                  <div className="gender-fill-summary female-fill-summary" style={{ width: `${femalePercentage}%` }}></div>
                </div>
              </div>
              {/* <div className="gender-row-summary">
                <div className="gender-label-summary">अन्य</div>
                <div className="gender-value-summary">{stats.otherCount.toLocaleString()}</div>
                <div className="gender-bar-summary">
                  <div className="gender-fill-summary female-fill-summary" style={{ width: `${femalePercentage}%` }}></div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateSummary;
